import {
  RegistrationSlot,
  UserEntityRegistrations
} from '@core/models/entities/implementations/user-entity-registrations';

export type RegistrationKind = 'vehicle' | 'trailer' | 'driver';

export interface KindDescriptor {
  kind: RegistrationKind;
  resourceField: 'vehicle_uid' | 'trailer_uid' | 'driver_uid';
  registrationField:
    | 'vehicle_registration'
    | 'trailer_registration'
    | 'driver_registration';
  scopeField: 'vehicleUids' | 'trailerUids' | 'driverUids';
  entityType: string;
  versionName: string;
  /** Only the vehicle slot appears in a route's name. */
  affectsName: boolean;
}

export const REGISTRATION_KINDS: readonly KindDescriptor[] = [
  {
    kind: 'vehicle',
    resourceField: 'vehicle_uid',
    registrationField: 'vehicle_registration',
    scopeField: 'vehicleUids',
    entityType: 'VEHICLE',
    versionName: 'UserVehicle',
    affectsName: true
  },
  {
    kind: 'trailer',
    resourceField: 'trailer_uid',
    registrationField: 'trailer_registration',
    scopeField: 'trailerUids',
    entityType: 'TRAILER',
    versionName: 'UserTrailer',
    affectsName: false
  },
  {
    kind: 'driver',
    resourceField: 'driver_uid',
    registrationField: 'driver_registration',
    scopeField: 'driverUids',
    entityType: 'DRIVER',
    versionName: 'UserDriver',
    affectsName: false
  }
];

export interface RoutePatch {
  uid: string;
  vehicle_registration?: RegistrationSlot;
  trailer_registration?: RegistrationSlot;
  driver_registration?: RegistrationSlot;
  name?: string;
}

export interface UnrepairedSlot {
  routeUid: string;
  kind: RegistrationKind;
  resourceUid: string;
  /** 0 when the resource never loaded, so its slot set is unknown. */
  totalSlots: number;
}

/**
 * Per kind, a resource uid to its registrations. A key absent from the map means the resource
 * never loaded; a key present with `undefined` means it loaded and declares no registrations.
 */
export type ResourceRegistrationsByKind = Record<
  RegistrationKind,
  Map<string, UserEntityRegistrations | undefined>
>;

export interface RegistrationRepairOutcome {
  repaired: number;
  unrepaired: UnrepairedSlot[];
  /** The pass could not complete: a query, a resource fetch or a write failed. */
  incomplete: boolean;
}
